import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import DDOption from '../models/DropdownModels';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/apiConfig';


function ReportDropdown({ onReportChange }) {
    const [selectedReportOption, setSelectedReportOption] = useState([]);
    const [getReportOptions, setReportOptions] = useState([]);
    const [ReportChanged, setReportChanged] = useState(false);

    function handleChange(e) {
        setSelectedReportOption(e);
        setReportChanged(true);
        onReportChange(e); 
        // if(e !== null){
        //     setClientCompany((prevState) => ({
        //         ...prevState,
        //         ClientCompanyTypeId: e.value
        //     }));
        // } else {
        //     setClientCompany((prevState) => ({
        //         ...prevState,
        //         ClientCompanyTypeId: null
        //     }));
        // }
    };

    const fetchReport = async () => {
        try {
            let selectedReport = {
                UserId: localStorage.getItem("userId")
            };
            const response = await axios.get(getApiBaseUrl() + "/reportlist", {params: selectedReport});
            if (response.status === 200) {
                setReportDropdownData(response.data.data[0]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    function setReportDropdownData(cct) {
        let allReportOpt = [];
        allReportOpt = cct.map(p => ({ value: p.ReportId, label: p.ReportName, name: p.ReportName.replace(/\s+/g, ''), description: '', isFixed: false, isDisabled: false, groupId: null }))
        setReportOptions(allReportOpt);
    }

    useEffect(() => {
        fetchReport();
    }, []);
    return (
        <div className="col-12">
            <div className="mb-3">
                
                <Select
                    name="ReportId"
                    value={selectedReportOption ? selectedReportOption : []}
                    isClearable={true}
                    options={getReportOptions || []}
                    onChange={(e) => handleChange(e)}
                />
            </div>
        </div>
    )
}

export default ReportDropdown